<!--&lt;!&ndash;Navbar&ndash;&gt;-->
<!--<mdb-navbar  SSideClass="navbar navbar-expand-lg navbar-dark indigo">-->

<!--  &lt;!&ndash; Navbar brand &ndash;&gt;-->
<!--  <mdb-navbar-brand><a [ngStyle]="{'color': colorSelected}" class="navbar-brand" routerLink="/">ABIDAR YASSINE</a>-->
<!--  </mdb-navbar-brand>-->

<!--  &lt;!&ndash; Collapsible content &ndash;&gt;-->
<!--  <links>-->

<!-- Links -->
<!--    <ul class="navbar-nav ml-auto cl-effect-4">-->
<!--      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">-->
<!--        <a  routerLink="/" class="nav-link waves-light" mdbWavesEffect>Accuiel<span-->
<!--          class="sr-only">(current)</span></a>-->
<!--      </li>-->
<!--      <li class="nav-item" routerLinkActive="active">-->
<!--        <a  routerLink="/about" class="nav-link waves-light " mdbWavesEffect>A-->
<!--          Propos</a>-->
<!--      </li>-->
<!--      <li class="nav-item" routerLinkActive="active ">-->
<!--        <a  routerLink="/education" class="nav-link waves-light" mdbWavesEffect>Education</a>-->
<!--      </li>-->
<!--      <li class="nav-item" routerLinkActive="active ">-->
<!--        <a routerLink="/skills" class="nav-link waves-light"-->
<!--           mdbWavesEffect>Skills</a>-->
<!--      </li>-->
<!--      <li class="nav-item" routerLinkActive="active ">-->
<!--        <a routerLink="/certificats" class="nav-link waves-light" mdbWavesEffect>Certificats</a>-->
<!--      </li>-->
<!--      <li class="nav-item" routerLinkActive="active ">-->
<!--        <a  routerLink="/contact" class="nav-link waves-light" mdbWavesEffect>Contact</a>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </links>-->


<!--</mdb-navbar>-->
<!--&lt;!&ndash;/.Navbar&ndash;&gt;-->
<!--Navbar-->
<mdb-navbar [ngClass]="['background-color', 'colorSelected']" SideClass="navbar navbar-expand-lg navbar-dark indigo">

  <!-- Navbar brand -->
  <mdb-navbar-brand><a class=" navbar-brand" routerLink="/">Abidar Yassine</a></mdb-navbar-brand>

  <!-- Collapsible content -->
  <links>

    <!-- Links -->
    <ul class="navbar-nav ml-auto cl-effect-4">
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <a routerLink="/" class="nav-link waves-light" mdbWavesEffect>Accuiel<span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a href="#about" target="_self" class="nav-link waves-light " mdbWavesEffect>A
          Propos</a>
      </li>
      <li class="nav-item" routerLinkActive="active ">
        <a href="#education" target="_self" class="nav-link waves-light" mdbWavesEffect>Education</a>
      </li>
      <li class="nav-item" routerLinkActive="active ">
        <a href="#skills" target="_self" class="nav-link waves-light" mdbWavesEffect>Skills</a>
      </li>
      <li class="nav-item" routerLinkActive="active ">
        <a routerLink="/certificats" class="nav-link waves-light" mdbWavesEffect>Certificats</a>
      </li>
      <li class="nav-item" routerLinkActive="active ">
        <a href="#contact" class="nav-link waves-light" mdbWavesEffect>Contact</a>
      </li>
    </ul>
  </links>
  <!-- Collapsible content -->

</mdb-navbar>
<!--/.Navbar-->